import axios from "axios";
import qs from 'qs';

const controller = new AbortController();

const axiosInstance = axios.create({
	signal: controller.signal,
	validateStatus: (status) => (status >= 200 && status < 300) || status === 422,
	paramsSerializer: params => {
		return qs.stringify(params, { arrayFormat: "repeat" })
	}
});

axiosInstance.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (error.response.status === 401) {
			// Token is no longer valid — clear announcement "seen" flags
			// so announcements re-show after the next successful login
			localStorage.removeItem("announcementNotice_vvv");
			localStorage.removeItem("announcementNotice_cs");
			controller.abort();
		}
		return Promise.reject(error.response);
	}
);

export { axiosInstance as HttpClient };
